export enum CmsEntities {
    TEMPLATES = 'templates',
    RELEASES = 'releases',
    AI_ASSISTANT_SHORTCUTS = 'ai-assistant-shortcuts',
    EMOJI = 'emoji',
    SEGMENTS = 'segments',
    SEGMENTS_MOST_RELEVANT = 'segments/most-relevent',
}
